import React, { useState } from "react";
import { Container, Title, Group, Select, Loader, Center } from "@mantine/core";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { bridgeService } from "../../../services/bridgeService";
import { DeviceEventTable } from "../../../components/bridge";
import { useBridgeStatus } from "../../../hooks/useBridgeStatus";

const BridgeDeviceEventLog: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [eventTypeFilter, setEventTypeFilter] = useState<string | null>(null);
  useBridgeStatus();

  const { data, isLoading } = useQuery({
    queryKey: ["bridge-events", id, eventTypeFilter],
    queryFn: () =>
      bridgeService.getEvents(id!, {
        eventType: eventTypeFilter || undefined,
        limit: 100,
      }),
    select: (res) => res.data,
    enabled: !!id,
  });

  return (
    <Container size="xl" py="md">
      <Title order={2} mb="lg">
        Device Event Log
      </Title>

      <Group mb="md">
        <Select
          placeholder="Filter by event type"
          data={[
            { value: "barcode_scanned", label: "Barcode Scanned" },
            { value: "print_completed", label: "Print Completed" },
            { value: "error", label: "Error" },
            { value: "status_change", label: "Status Change" },
          ]}
          value={eventTypeFilter}
          onChange={setEventTypeFilter}
          clearable
        />
      </Group>

      {isLoading ? (
        <Center py="xl">
          <Loader />
        </Center>
      ) : (
        <DeviceEventTable events={data?.data || []} />
      )}
    </Container>
  );
};

export default BridgeDeviceEventLog;
